import FinanceApi from '@/services/FinanceApi';

const getAll = async (config) => {
    return FinanceApi.get('/customer/budgets', config);
}
const get = async (id) => {
    return FinanceApi.get('/customer/budgets/' + id);
}
const store = async (data) => {
    return FinanceApi.post('/customer/budgets', data);
}
const update = async (id, formData) => {
    return FinanceApi.put('/customer/budgets/' + id, formData);
}
const del = async (id) => {
    return FinanceApi.delete('/customer/budgets/' + id);
}
const search = async (config) => {
    return FinanceApi.get('/customers/search', config);
}
const exportExcel = async (config) => {
    return FinanceApi.get('/customer/budgets/excel-export',{...config,responseType:'arraybuffer'});
}

export default {
    getAll,
    update,
    get,
    store,
    del,
    search,
    exportExcel
}
